import { Box, CircularProgress } from "@mui/material";

function RouteFallback() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        width: "100%",
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default RouteFallback;
